



































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Table from '@/components/Table.vue';
import ActionBarButton from '@/components/ActionBarButton.vue';
import {Getter} from 'vuex-class';
import AccOrgAutocomplete from '@/components/AccOrgAutocomplete.vue';
import GenericButton from '@/components/GenericButton.vue';
import AccountService from '@/services/account.service';
import Dialog from '@/components/Dialog.vue';
import {CommercialAccount, Organisation, Role, User} from '@/types';
import ConfirmButton from '@/components/ConfirmButton.vue';
import CancelButton from '@/components/CancelButton.vue';
import AccountOrganisationAccess from '@/views/accounts/AccountOrganisationAccess.vue';
import Transformation from '@/classes/transformation';
import SearchBar from '@/components/SearchBar.vue';
import moment from 'moment';
import EventBus from '@/services/eventbus.service';

@Component({
  components: {
    SearchBar,
    AccountOrganisationAccess,
    CancelButton, ConfirmButton, Dialog, GenericButton, AccOrgAutocomplete, ActionBarButton, Table},
})
export default class AccountUsers extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeAccountId: any;
  @Prop() private accountRoles!: Role[];
  @Prop() private orgRoles!: Role[];

  private newOrgs: Array<{ name: string }> = [];
  private orgsToAdd: any = [];
  private orgsToKeep: any = [];

  private loading: boolean = false;
  private auditLoading: boolean = false;
  private saving: boolean = false;
  private selected: any = [];
  private search: string = '';

  private defaultRoles: Role[] = [];
  private currentUser: any = null;
  private showAuditLogs: { [key: number]: boolean } = {};

  private itemsPerPage: number = 100;
  private perPage: number = 100;
  private page: number = 1;
  private queryData: any = {
    sort: 'user.last_name',
  };
  private auditItemsPerPage: number = 100;
  private auditPerPage: number = 100;
  private auditPage: number = 1;
  private auditQueryData: any = {
    sort: 'audit.created_at',
  };
  private allUsers: { rows: any[]; headers: any[]; total: number } = {
    rows: [],
    total: 0,
    headers: [
      {
        text: 'First Name',
        value: 'first_name',
        filterable: false,
        sortable: true,
        queryKey: 'firstName',
        querySortKey: 'user.first_name',
      },
      {
        text: 'Last Name',
        value: 'last_name',
        filterable: false,
        sortable: true,
        queryKey: 'lastName',
        querySortKey: 'user.last_name',
      },
      {
        text: 'Email',
        value: 'email',
        filterable: false,
        sortable: true,
        queryKey: 'email',
        querySortKey: 'user.email',
      },
      {
        text: 'Status',
        value: 'status',
        filterable: true,
        queryKey: 'statuses',
        querySortKey: 'user.status',
      },
      {
        text: 'Account role',
        value: 'account_roles',
        filterable: true,
        hideSort: true,
        queryKey: 'accountRoles',
        querySortKey: 'role.name',
      },
      {
        text: 'Organisation access',
        value: 'organisations',
        filterable: true,
        hideSort: true,
        queryKey: 'organisations',
        querySortKey: 'organisation.name',
      },
      {
        text: 'MFA enabled',
        value: 'mfaEnabled',
        filterable: true,
        hideSort: true,
        queryKey: 'mfaEnabled',
        querySortKey: 'user.mfa_enabled',
      },
      {
        text: 'Last login',
        value: 'last_login',
        filterable: false,
        hideSort: true,
        queryKey: 'lastLogin',
        querySortKey: 'user.last_login',
      },
      { text: '', value: 'actions' },
    ],
  };
  private allAudit: { rows: any[]; headers: any[]; total: number } = {
    rows: [],
    total: 0,
    headers: [
      {
        text: 'Category',
        value: 'category',
        filterable: true,
        sortable: true,
        queryKey: 'categories',
        querySortKey: 'audit.category',
      },
      {
        text: 'Subcategory',
        value: 'sub_category',
        filterable: true,
        sortable: true,
        queryKey: 'subCategories',
        querySortKey: 'audit.sub_category',
      },
      {
        text: 'Organisation',
        value: 'organisation',
        filterable: true,
        sortable: true,
        queryKey: 'organisations',
        querySortKey: 'organisation.name',
      },
      {
        text: 'Summary',
        value: 'summary',
        filterable: false,
        sortable: false,
        hideSort: true,
        queryKey: 'summary',
        querySortKey: 'audit.summary',
      },
      {
        text: 'Activity logged at',
        value: 'created_at',
        filterable: false,
        queryKey: 'created_at',
        querySortKey: 'audit.created_at',
        width: '150px',
      },
    ],
  };
  private accountUserEditDialog: {[key: number]: boolean} = {};
  private removeAccessDialog: boolean = false;
  private editFormValid: boolean = true;
  private inviteResent: boolean = false;

  private async mounted() {
    this.loading = true;
    try {
      await this.getUsers();
    } finally {
      this.loading = false;
    }
  }

  private async getUsers(
    queryData: {
      take?: number;
      skip?: number;
      sort?: string;
      desc?: boolean;
      filters?: { [key: string]: any }; } = this.queryData,
    search: string = this.search) {
    this.loading = true;
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;

    try {
      const {
        users,
        total,
        columnFilters,
      } = await AccountService.getAccountUsers(this.activeAccountId, take, queryData.skip, queryData.sort, queryData.desc, mappedFilters, search);
      this.allUsers.rows = users.map((user: any) => {
        user.mfaEnabled = user.mfa_enabled ? 'Yes' : 'No';
        user.last_login = this.formatDate(user.last_login) || 'Never';
        return user;
      });
      this.allUsers.total = total;
      Transformation.setTableFilterValues(this.allUsers.headers, columnFilters);

      this.loading = false;

    } finally {
      this.loading = false;
    }
  }

  private async resendPassword(user: User) {
    await AccountService.resendPassword(this.activeAccountId, user.id);
    this.inviteResent = true;
  }

  private async onQueryDataUpdate(data: object) {
    this.queryData = data;
    await this.getUsers(data);
  }

  private customSort(items: any[]) {
    return items.sort((a, b) => - a.created_at.localeCompare(b.created_at));
  }

  private handleRowClicked(user: User) {
    Vue.set(this.accountUserEditDialog, user.id, true);
    this.currentUser = {...user};
  }

  private async resetDialog() {
    await this.getUsers();
    this.orgsToKeep = [];
    this.orgsToAdd = [];
    this.newOrgs = [];
    this.defaultRoles = [];
    this.inviteResent = false;
  }

  private async onAuditQueryDataUpdate(data: any) {
    if (!data.sort) {
      data.sort = 'audit.created_at';
      data.desc = true;
    }
    this.auditQueryData = data;
    await this.getAudit(data, undefined, this.currentUser.id);
  }

  private async getAudit(
      queryData: {
        take?: number;
        skip?: number;
        sort?: string;
        desc: boolean;
        filters?: { [key: string]: any }; } = this.auditQueryData,
      search: string = this.search,
      userId: number | null = null,
  ) {
    this.auditLoading = true;
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;

    try {
      const {
        audits,
        total,
        columnFilters,
      } = await AccountService.getAccountUserAudit(this.activeAccountId, take, queryData.skip, queryData.sort, queryData.desc, mappedFilters, search, userId);
      this.allAudit.rows = audits;
      this.allAudit.total = total;
      Transformation.setTableFilterValues(this.allAudit.headers, columnFilters);

      this.auditLoading = false;

    } finally {
      this.auditLoading = false;
    }
  }

  private async exportCsv(user: User) {
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(this.auditQueryData.filters);
    try {
      const params: {
        take: number;
        skip?: number;
        sort?: string;
        desc?: boolean;
        organisationId?: number;
        search?: string;
        userId?: number;
        filters?: any;
      } = {
        take: this.auditQueryData.itemsPerPage,
        sort: this.auditQueryData.sort,
      };

      if (this.auditQueryData.page > 1) {
        params.skip = this.auditQueryData.itemsPerPage * (this.auditQueryData.page - 1);
      }
      if (this.auditQueryData.sort) {
        params.desc = this.auditQueryData.desc;
      }
      if (user && user.id) {
        params.userId = user.id;
      }

      params.filters = {...this.convertToArray(mappedFilters)};

      const {job_id} = await AccountService.exportAccountUserAudits(this.activeAccountId, params);
      EventBus.$emit('accountJobCreated', job_id, true);
    } finally {
      this.auditLoading = false;
    }
  }

  private async exportUsersCsv() {
    const params: {
      sort?: string;
      desc?: boolean;
      search?: string;
      filters?: any;
      userIds?: number[];
    } = {
      sort: this.queryData.sort,
      desc: this.queryData.desc,
      filters: this.convertToArray(Transformation.tableFiltersToMap(this.queryData.filters)),
    };

    if (this.search && this.search.trim().length) {
      params.search = this.search.trim();
    }

    if (this.selected.length) {
      params.userIds = this.selected.map((user: { id: number }) => user.id);
    }

    const {job_id} = await AccountService.exportAccountUsers(this.activeAccountId, params);
    EventBus.$emit('accountJobCreated', job_id, true);
  }

  private convertToArray(inputObject: any) {
    const outputObject: any = {};

    for (const outerKey in inputObject) {
      if (inputObject.hasOwnProperty(outerKey)) {
        outputObject[outerKey] = [];
        for (const innerKey in inputObject[outerKey]) {
          if (inputObject[outerKey][innerKey]) {
            outputObject[outerKey].push(innerKey);
          }
        }
      }
    }

    return outputObject;
  }

  private async showUserAudit(item: User) {
    Vue.set(this.showAuditLogs, item.id, true);
    this.currentUser = item;
    await this.getAudit(this.auditQueryData, undefined, item.id);
  }


  private closeAuditDialog(item: User) {
    Vue.set(this.showAuditLogs, item.id, false);
    this.currentUser = null;
    this.allAudit.rows = [];
    this.allAudit.total = 0;
  }

  private async saveUser() {
    this.saving = true;
    try {
      const currentOrgs = this.currentUser.organisations || [];
      this.orgsToKeep = [...this.orgsToAdd, ...currentOrgs];
      const orgIdsWithRolesToKeep = this.orgsToKeep.flatMap((o: { id: number, roles: Role[] }) => {
        return o.roles.map((r: Role) =>  {
          return { organisationId: o.id, roleId: r.id };
        });
      });
      await AccountService.updateUserAccess(this.activeAccountId, this.currentUser.id, {
        accountRoleIds: this.currentUser.accountRoles ? this.currentUser.accountRoles.map((ar: Role) => ar.id) : null,
        organisationsWithRoles: orgIdsWithRolesToKeep,
      });
    } finally {
      this.saving = false;
      await this.getUsers();
      await this.resetDialog();
    }
  }

  private async searchUsers(searchText: string) {
    this.search = searchText;
    this.page = 1;

    await this.$nextTick();
    await this.getUsers();
  }

  private async removeAccountUsers() {
    this.loading = true;
    try {
      const userIds = this.selected.map((user: { id: number }) => user.id);
      await AccountService.removeAccountUsers(this.activeAccountId, { userIds });
    } finally {
      this.removeAccessDialog = false;
      await this.getUsers();
      this.loading = false;
      this.selected = [];
    }

  }

  private formatDate(date?: Date | null) {
    if (!date) {
      return '';
    }

    return moment(date).format('DD MMM YYYY HH:mm:ss');
  }

}
